// Route paths
export const ROUTES = {
  // Auth
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  LOGOUT: '/logout',

  // Dashboard
  DASHBOARD: '/dashboard',

  // Bots
  BOTS: '/bots',
  BOT_CREATE: '/bots/create',
  BOT_EDIT: '/bots/:id/edit',
  BOT_EDITOR: '/bots/:id/editor',

  // Tenants
  TENANTS: '/tenants',
  TENANT_CREATE: '/tenants/create',
  TENANT_EDIT: '/tenants/:id/edit',

  // Analytics
  ANALYTICS: '/analytics',
  REPORTS: '/analytics/reports',

  // Logs
  LOGS_CHAT: '/logs/chat',
  LOGS_API: '/logs/api',
  LOGS_AI: '/logs/ai',

  // Live Chat
  LIVECHAT: '/livechat',

  // Channels
  CHANNELS: '/channels',

  // Config
  BOT_CONFIG: '/bots/:id/config',

  // Custom Actions
  CUSTOM_ACTIONS: '/custom-actions',
  ACTION_EDITOR: '/custom-actions/:id/edit',
};

// User Roles
export const ROLES = {
  SUPER_ADMIN: 'superadmin',
  TENANT_ADMIN: 'admin',
  BOT_CREATOR: 'creator',
  SUPPORT_AGENT: 'agent',
} as const;

/** Visible product name and tagline (shell, browser title). */
export const BRAND_NAME = 'Echo';
export const BRAND_TAGLINE = 'Enterprise Chatbot Platform';

/** Public path under `studio/public` — login shell + app chrome. */
export const BRAND_LOGO_URL = '/Netcore-Chatbot-Logo.png';

/** Login / forgot-password shell background (`studio/public`). */
export const BRAND_LOGIN_BG_URL = '/Echo-Chatbot-NetcoreCloud-BG.jpg';

/** Shown on login footer only (vendor attribution). */
export const BRAND_VENDOR_FOOTER = 'Echo by Netcore Cloud';

// Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
  USER: 'user',
  THEME: 'theme',
} as const;

